export const RESTRICTED_DOCUMENT_ERROR_MESSAGE = 'Public access to this document has been restricted by the court.';
export const ERROR_DOWNLOAD_DOCUMENT_MESSAGE = 'There was an issue with retrieving the document. Please try again.';
export const DOWNLOAD_DOCUMENT_TAKING_LONGER_WARNING_MESSAGE =
  'It’s taking a little longer, but we’re still retrieving your document.';
